module.exports = __webpack_public_path__ + "img/icon_kekcjjslt.86b596dc.png";